import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawRewardIcon from "./RawRewardIcon.svg.jsx";

const RewardIcon = forwardRef((props, ref, css) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawRewardIcon}
      data-testid="reward-icon"
      css={css}
      {...props}
    />
  );
});

export default RewardIcon;
